module.exports = __webpack_public_path__ + "static/media/10valkas_edited.5a061c75.jpg";